import Cookies from "universal-cookie";
import { API_URL } from "../../../constants/urlConstants";
import { baseUrl, basePYUrl } from "../../PostAPI";
import { post, put, CancelToken } from "axios";
import { APIError, handleAPIError } from "../../common/errorHandler";
const cookies = new Cookies();

let cancelUpload;

export const cancelDailyRatesUpload = () => {
  if (cancelUpload) {
    cancelUpload("Upload cancelled by user.");
  }
};

export const uploadDailyRates = async (payload) => {
  const { type, file, ta_petro_file, pilot_file, price_date } = payload;
  const token = cookies.get("authorization");

  // Select the correct endpoint based on type
  const isMulti = type === "ALL-USD";
  
  // Build URL with optional price_date parameter
  let url = isMulti
    ? `${basePYUrl}${API_URL.DAILY_RATES.UPLOAD_MULTIPLE_DAILY_RATES}?Type=${type}`
    : `${basePYUrl}${API_URL.DAILY_RATES.UPLOAD_DAILY_RATES}?Type=${type}`;
  
  // Append price_date if provided
  if (price_date) {
    url += `&price_date=${price_date}`;
  }

  // Build the form data dynamically
  const formData = new FormData();
  if (isMulti) {
    if (ta_petro_file) formData.append("ta_petro_file", ta_petro_file);
    if (pilot_file) formData.append("pilot_file", pilot_file);
  } else if (file) {
    formData.append("file", file);
  }

  try {
    const response = await post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: token,
        Accept: "application/json",
      },
      cancelToken: new CancelToken((c) => (cancelUpload = c)),
    });

    return response.data;
  } catch (error) {
    console.error("Error uploading daily rates:", error);
    return handleAPIError(error);
  }
};

// Helper function to handle API requests (like POST and PUT for other actions)
const dataUploadApi = (url, data, isEdit = false) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      authorization: cookies.get("authorization"),
    },
  };

  if (isEdit) {
    return put(baseUrl + url, data, config);
  } else {
    return post(baseUrl + url, data, config);
  }
};
